import { Injectable } from '@angular/core';
import { Auth } from '../auth/auth';
import { HttpHeaders, HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError, Subject } from 'rxjs';
import { CompanyData } from '../auth/company-data';
import { environment } from '../../environments/environment';
import { AddCurrency } from '../auth/addCurrency';
import { UpdateProfile } from '../auth/updateProfile';
import { gradeuRule } from '../auth/gradeRule';
import moment from 'moment';
import { AppDialogService } from '../shared/app-dialog/app-dialog.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  endpoint: string = environment.apiBaseUrl;
  headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');//Set a Header Value.
  params = new HttpParams().set("startDate",moment().startOf('days').toLocaleString());
  isSidebarPinned = false;
  isSidebarToggeled = false;
  
  public sidebarToggleSubject = new Subject<void>();
  public companyUpdateSubject = new Subject<void>();
  
  triggerSidebarToggle() {
    this.sidebarToggleSubject.next();
  }

  triggerCompanyUpdate() {
    this.companyUpdateSubject.next();
  }

  constructor(private http: HttpClient, private dialogs: AppDialogService) { }

  //Method for calling Register API
  submitSignup(data: Auth): Observable<any> {
    try {
      data.redirectUrl = `${environment.appBaseUrl}/users/generate-password`;   // Provide daynamic environment
      let apiURL = `${this.endpoint}/user/signup-via-email`;
      return this.http.post(apiURL, data).pipe(
        catchError(this.errorMgmt)
      )
    }
    catch (err) {
      console.log(err);
    }
  }

  // Method to complete onboarding tour
  completeTour(): Observable<any> {
    try {
      let apiURL = `${this.endpoint}/users/complete-tour`;
      const token = sessionStorage.getItem('jwtToken');
      const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
      return this.http.put(apiURL, {}, { headers }).pipe(
        catchError(this.errorMgmt)
      )
    }
    catch (err) {
      console.log(err);
    }
  }

  //Method for calling login API
  submitLogin(data: Auth): Observable<any> {
    try {
      let apiURL = `${this.endpoint}/users/login`;
      return this.http.post(apiURL, data).pipe(
        catchError(this.errorMgmt)
      )
    }
    catch (err) {
      console.log(err);
    }
  }

  //Method for Submit password and calling API
  submitPasswordData(data: Auth, token: string): Observable<any> {
    try {
      data.token = token;
      let apiURL = `${this.endpoint}/user/confirm-registration`;
      return this.http.post(apiURL, data).pipe(
        catchError(this.errorMgmt)
      )
    }
    catch (err) {
      console.log(err);
    }
  }

  //Method for Submit forgot mail and calling API
  submitForgotPasswordData(data: Auth): Observable<any> {
    try {
      data.redirectUrl = `${environment.appBaseUrl}/users/reset-password`;
      let apiURL = `${this.endpoint}/user/password/request-reset`;
      return this.http.post(apiURL, data).pipe(
        catchError(this.errorMgmt)
      )
    }
    catch (err) {
      console.log(err);
    }
  }

  //Method for Submit password and calling API
  submitResetPasswordData(data: Auth, token: string): Observable<any> {
    try {
      data.token = token;
      let apiURL = `${this.endpoint}/user/password/set`;
      return this.http.post(apiURL, data).pipe(
        catchError(this.errorMgmt)
      )
    }
    catch (err) {
      console.log(err);
    }
  }


  //Create method for manage errors when request and return response from the server
  errorMgmt = (error: HttpErrorResponse) => {
    try {
      let errorMessage = '';
      //Handle client side error
      if (error.error instanceof ErrorEvent) {
        errorMessage = error.error.message;
      }
      //Handle server side error
      else {
        // Extract message from server response if available
        errorMessage = error.error && error.error.message ? error.error.message : error.message;
      }
      
      // Enhance error message for end users
      let errorTitle = 'Oops...';
      let errorVariant: any = 'error';
      
      if (error.status === 0) {
        errorTitle = 'Connection Error';
        errorMessage = 'Unable to connect to the server. Please check if the server is running or your internet connection.';
        errorVariant = 'info';
      } else if (error.status === 404) {
        errorTitle = 'Not Found';
        errorMessage = 'The requested resource could not be found on the server.';
      } else if (error.status === 500) {
        errorTitle = 'Server Error';
        errorMessage = 'Something went wrong on our end. Please try again later.';
      } else if (error.status === 401 || error.status === 403) {
        errorTitle = 'Permission Denied';
        errorMessage = 'You are not authorized to perform this action.';
      }

      // Show Global Alert with premium styling - Skip for 400 validation errors as they are handled on-page
      if (error.status !== 400) {
        // Fire-and-forget, do not block the observable chain
        this.dialogs.alert({
          title: errorTitle,
          message: errorMessage,
          variant: errorVariant
        });
      }


      console.log(errorMessage);
      return throwError(errorMessage);
    }
    catch (err) {
      console.log(err);
      return throwError(err);
    }
  }


//Method for logout
  submitLogout(): void {
    const token = sessionStorage.getItem('jwtToken');
    if (token && token !== 'undefined') {
      this.http.post(`${this.endpoint}/user/logout`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      }).subscribe({ error: () => {} });
    }
    ['token', 'jwtToken', 'companyId', 'myVal', 'isFirstLogin'].forEach((key) =>
      sessionStorage.removeItem(key)
    );
  }

  //Method for submit company form Data and calling API
  submitCompanyData(data: CompanyData,countryName,stateName): Observable<any> {
    try {
      data.countryName = countryName;
      data.stateName = stateName;
      const parentUserId = sessionStorage.getItem("token");
      let apiURL = `${this.endpoint}/company/add-company/${parentUserId}`;
      return this.http.post(apiURL, data).pipe(
        catchError(this.errorMgmt)
      )
    }
    catch (err) {
      console.log(err);
    }
  }

  // Method for add currency
  submitCurrency(data: AddCurrency): Observable<any>{
    try{
      const userId = sessionStorage.getItem('token');
      let apiURL = `${this.endpoint}/company/add-currency/${userId}`;
      return this.http.post(apiURL, data).pipe(
        catchError(this.errorMgmt)
      )
    } catch(err){
      console.log(err);
    }
  }

  // List Currency
  listCurrency(): Observable<any>{
    try{
      const userId = sessionStorage.getItem('token');
      let apiURL = `${this.endpoint}/company/list-currency/${userId}`;
      return this.http.get(apiURL).pipe(
        catchError(this.errorMgmt)
      )
    } catch(err){
      console.log(err);
    }
  }

  //Method for submit updated company form Data and calling API
  submitUpdateCompanyData(data: CompanyData,companyId: String): Observable<any> {
    try {
      const parentUserId = sessionStorage.getItem("token");
      let apiURL = `${this.endpoint}/company/update-company/${parentUserId}/${companyId}`;
      return this.http.post(apiURL, data).pipe(
        catchError(this.errorMgmt)
      )
    }
    catch (err) {
      console.log(err);
    }
  }

// Method for get data from server and show company list
  getListData(): Observable<any> {
    try {
      const parentUserId = sessionStorage.getItem("token");
      let apiURL = `${this.endpoint}/company/company-list/${parentUserId}`;
       return this.http.get(apiURL).pipe(
         catchError(this.errorMgmt)
       )
    }
    catch (err) {
      console.log(err);
    }
  }

  // Method for get individual company data
  getIndividualData(companyId:String):Observable<any>{
    try{
      let apiURL = `${this.endpoint}/company/details/${companyId}`;
      return this.http.get(apiURL, {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${(sessionStorage.getItem('jwtToken'))}`),
      }).pipe(
           catchError(this.errorMgmt)
         );
    }catch(err){
      console.log(err);
    }
  }

  // Get Employee Settings
  getEmployeeSettings(companyId: string): Observable<any> {
    try {
      let apiURL = `${this.endpoint}/settings/employee-settings/${companyId}`;
      return this.http.get(apiURL, {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${(sessionStorage.getItem('jwtToken'))}`),
      }).pipe(
        catchError(this.errorMgmt)
      );
    } catch (err) {
      console.log(err);
    }
  }

  // Attendance mode settings (GPS / GPS_FACE / MACHINE)
  getAttendanceModeSettings(companyId: string): Observable<any> {
    try {
      const apiURL = `${this.endpoint}/settings/attendance-mode/${companyId}`;
      return this.http.get(apiURL, {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${(sessionStorage.getItem('jwtToken'))}`),
      }).pipe(
        catchError(this.errorMgmt)
      );
    } catch (err) {
      console.log(err);
    }
  }

  saveAttendanceModeSettings(companyId: string, data: any): Observable<any> {
    try {
      const apiURL = `${this.endpoint}/settings/attendance-mode/${companyId}`;
      return this.http.post(apiURL, data, {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${(sessionStorage.getItem('jwtToken'))}`),
      }).pipe(
        catchError(this.errorMgmt)
      );
    } catch (err) {
      console.log(err);
    }
  }

  // Save Employee Settings
  saveEmployeeSettings(companyId: string, data: any): Observable<any> {
    try {
      let apiURL = `${this.endpoint}/settings/employee-settings/${companyId}`;
      return this.http.post(apiURL, data, {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${(sessionStorage.getItem('jwtToken'))}`),
      }).pipe(
        catchError(this.errorMgmt)
      );
    } catch (err) {
      console.log(err);
    }
  }

//Method for Delete data of company list
    removeData(companyId:String):Observable<any>{
      try{
        let apiURL = `${this.endpoint}/company/delete-company/${companyId}`;
        return this.http.delete(apiURL).pipe(
          catchError(this.errorMgmt)
        )
      }
      catch(err){
        console.log(err);
      }
    }

  // Upload Company Logo and Company Report Logo
  uploadCompanyLogo(data, type, isCompanyLogo, companyId): Observable<any> {
    try {
      const formData = new FormData();
      formData.append('companyLogo', data.get('companyLogo').value);
      let apiUrl = `${this.endpoint}/company/upload-logo/${companyId}/${type}/${isCompanyLogo}`;
      
      const headers = new HttpHeaders().set('Authorization', `Bearer ${sessionStorage.getItem('jwtToken')}`);
      
      return this.http.post<any>(apiUrl, formData, { headers }).pipe(
        catchError(this.errorMgmt)
      )
    } catch (error) {
      console.log(error);
    }
  }


  // Method for get User Details
  getUserDetails(): Observable<any> {
    try {
      let userId = sessionStorage.getItem('token');
      if (!userId || userId === 'undefined' || userId === 'null') {
        return new Observable(observer => {
          observer.next({ status: 'error', message: 'No user ID found' });
          observer.complete();
        });
      }
      let apiURL = `${this.endpoint}/user-details/${userId}`;
      const headers = new HttpHeaders().set('Authorization', `Bearer ${sessionStorage.getItem('jwtToken')}`);
      return this.http.get(apiURL, { headers }).pipe(
        catchError(this.errorMgmt)
      )
    } catch (err) {
      console.log(err);
      return throwError(err);
    }
  }

  // Get Time Zones
  getTimeZone(): Observable<any>{
    try {
      let apiURL = `${this.endpoint}/availabe-timezone`;
      return this.http.get(apiURL).pipe(
        catchError(this.errorMgmt)
      )
    } catch (error) {
      console.log(error);
    }
  }

  // Update User Profile
  updateUSerProfile(data: UpdateProfile, timezone): Observable<any> {
    try {
      data.timeZone = timezone;
      let userId = sessionStorage.getItem('token');
      let apiUrl = `${this.endpoint}/user/update-details/${userId}`;
      
      const headers = new HttpHeaders().set('Authorization', `Bearer ${sessionStorage.getItem('jwtToken')}`);
      console.log('Updating user profile at:', apiUrl);

      return this.http.post(apiUrl, data, { headers }).pipe(
        catchError(this.errorMgmt)
      )
    } catch (error) {
      console.log('Error in updateUSerProfile:', error);
      return throwError(error);
    }
  }

  // Upload Profile Image
  uploadProfileImage(data: any, type: string, employeeId?: string): Observable<any> {
    try {
      let companyId, userId;
      if (type === 'User') {
        userId = sessionStorage.getItem('token');
        companyId = undefined;
      } else if (type === 'Employee') {
        companyId = sessionStorage.getItem('companyId') || sessionStorage.getItem('companyId');
        // Handle "undefined" string from localStorage
        if (companyId === 'undefined' || !companyId) {
          companyId = null;
        }
        userId = employeeId;
      }

      let formData: FormData;
      if (data instanceof FormData) {
        formData = data;
      } else {
        formData = new FormData();
        const file = data.get ? data.get('avatar').value : data.avatar;
        formData.append('avatar', file);
      }

      // Add Authorization header which was missing
      const headers = new HttpHeaders().set('Authorization', `Bearer ${sessionStorage.getItem('jwtToken')}`);

      let apiUrl = `${this.endpoint}/user/upload-profile-picture/${userId}/${companyId}/${type}`;
      console.log('Uploading profile image to:', apiUrl);
      
      return this.http.post<any>(apiUrl, formData, { headers }).pipe(
        catchError(this.errorMgmt)
      );
    } catch (error) {
      console.error('Error in uploadProfileImage:', error);
      return throwError(error);
    }
  }

  permissionDetails(): Observable<any> {
    try {
      let userId = sessionStorage.getItem('token');
      if (!userId || userId === 'undefined' || userId === 'null') {
        // Return an observable that emits an error-like response or empty
        // instead of making a call that we know will fail on the server
        return new Observable(observer => {
          observer.next({ status: 'error', message: 'No user ID found' });
          observer.complete();
        });
      }
      let apiURL = `${this.endpoint}/user/permission-details/${userId}`;
      return this.http.get(apiURL, {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${(sessionStorage.getItem('jwtToken'))}`),
      }).pipe(
        catchError(this.errorMgmt)
      )
    } catch (error) {
      console.log(error);
      return throwError(error);
    }
  }

  //get Dashboard deatails
  dashboardDetails():Observable<any>{
    try {
      console.log(this.params);
      
      // let userId = sessionStorage.getItem('token');
      let apiURL = `${this.endpoint}/dasboard-deatils`;
      return this.http.get(apiURL, {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${(sessionStorage.getItem('jwtToken'))}`),
        params:this.params
      }).pipe(catchError(this.errorMgmt));
      
      // return this.http.get(apiURL).pipe(
      //   catchError(this.errorMgmt)
      // )
    } catch (error) {
      console.log(error);
    }
  }

  dashboardDetailsWithParams(params: any): Observable<any> {
    try {
      let apiURL = `${this.endpoint}/dasboard-deatils`;
      return this.http.get(apiURL, {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${(sessionStorage.getItem('jwtToken'))}`),
        params: params
      }).pipe(catchError(this.errorMgmt));
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  // Get User Permission
  getCompanyReport(startDate, endDate, gradeuRuleId):Observable<any>{
    try {
      let companyId = sessionStorage.getItem('companyId');
      let apiURL = `${this.endpoint}/company/excel-compnay-details/${companyId}/${startDate}/${endDate}/${gradeuRuleId}`;
      return this.http.get(apiURL).pipe(
        catchError(this.errorMgmt)
      )
    } catch (error) {
      console.log(error);
    }
  }

  toggleSidebar() {
    this.isSidebarToggeled = ! this.isSidebarToggeled;
  }

  toggleSidebarPin() {
    this.isSidebarPinned = ! this.isSidebarPinned;
  }

  getSidebarStat() {
    return {
      isSidebarPinned: this.isSidebarPinned,
      isSidebarToggeled: this.isSidebarToggeled
    }
  }

  // Get Location Tracking History
  getTrackingHistory(employeeId: string, date: string): Observable<any> {
    try {
      let apiURL = `${this.endpoint}/employee/tracking-history?employeeId=${employeeId}&date=${date}`;
      return this.http.get(apiURL, {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${(sessionStorage.getItem('jwtToken'))}`),
      }).pipe(
        catchError(this.errorMgmt)
      );
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  // Get notifications
  getNotifications(): Observable<any> {
    try {
      let apiURL = `${this.endpoint}/mobile/notification`;
      return this.http.get(apiURL, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${(sessionStorage.getItem('jwtToken'))}`)
      }).pipe(
        catchError(this.errorMgmt)
      );
    } catch (err) {
      console.log(err);
      return throwError(err);
    }
  }

  // Mark single notification as read
  markNotificationAsRead(notificationId: string): Observable<any> {
    try {
      let apiURL = `${this.endpoint}/mobile/notification/${notificationId}/read`;
      return this.http.put(apiURL, {}, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${(sessionStorage.getItem('jwtToken'))}`)
      }).pipe(
        catchError(this.errorMgmt)
      );
    } catch (err) {
      console.log(err);
      return throwError(err);
    }
  }

  // Mark all notifications as read
  markAllNotificationsAsRead(): Observable<any> {
    try {
      let apiURL = `${this.endpoint}/mobile/notification/read-all`;
      return this.http.put(apiURL, {}, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${(sessionStorage.getItem('jwtToken'))}`)
      }).pipe(
        catchError(this.errorMgmt)
      );
    } catch (err) {
      console.log(err);
      return throwError(err);
    }
  }

  // Delete all notifications for the user
  deleteAllNotifications(): Observable<any> {
    try {
      let apiURL = `${this.endpoint}/mobile/notification/delete-all`;
      return this.http.delete(apiURL, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${(sessionStorage.getItem('jwtToken'))}`)
      }).pipe(
        catchError(this.errorMgmt)
      );
    } catch (err) {
      console.log(err);
      return throwError(err);
    }
  }

  // Send Kudos (e.g., Birthday wishes)
  sendKudos(data: any): Observable<any> {
    try {
      let apiURL = `${this.endpoint}/kudos/send`;
      return this.http.post(apiURL, data, {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${(sessionStorage.getItem('jwtToken'))}`)
      }).pipe(
        catchError(this.errorMgmt)
      );
    } catch (err) {
      console.log(err);
      return throwError(err);
    }
  }

  verifyMfaLogin(mfaToken: string, code: string): Observable<any> {
    const apiURL = `${this.endpoint}/user/mfa/verify-login`;
    return this.http.post(apiURL, { mfaToken, code }).pipe(catchError(this.errorMgmt));
  }

  getMfaStatus(): Observable<any> {
    const apiURL = `${this.endpoint}/user/mfa/status`;
    return this.http.get(apiURL).pipe(catchError(this.errorMgmt));
  }

  setupMfa(method: 'totp' | 'email'): Observable<any> {
    const apiURL = `${this.endpoint}/user/mfa/setup`;
    return this.http.post(apiURL, { method }).pipe(catchError(this.errorMgmt));
  }

  sendMfaEmailOtp(): Observable<any> {
    const apiURL = `${this.endpoint}/user/mfa/send-email-otp`;
    return this.http.post(apiURL, {}).pipe(catchError(this.errorMgmt));
  }

  enableMfa(code: string): Observable<any> {
    const apiURL = `${this.endpoint}/user/mfa/enable`;
    return this.http.post(apiURL, { code }).pipe(catchError(this.errorMgmt));
  }

  disableMfa(code: string, password: string): Observable<any> {
    const apiURL = `${this.endpoint}/user/mfa/disable`;
    return this.http.post(apiURL, { code, password }).pipe(catchError(this.errorMgmt));
  }
}
